import * as React from 'react';

const InfoCircleFilled64 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 64 64", width: 64, height: 64, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M32 5.33C17.27 5.33 5.33 17.27 5.33 32S17.27 58.67 32 58.67 58.67 46.73 58.67 32 46.73 5.33 32 5.33M33.49 46h-3.01V26.998h3.01zm-1.5-22.25c-1.39 0-2.52-1.13-2.52-2.52s1.13-2.52 2.52-2.52 2.52 1.13 2.52 2.52-1.13 2.52-2.52 2.52"
  }
));
InfoCircleFilled64.Size = 64;
InfoCircleFilled64.Title = "InfoCircleFilled";

export { InfoCircleFilled64 as default };
